// AeflorCard.jsx
import React from "react";
import { Link } from "react-router-dom";
import './index.css';
import { formatInTimeZone } from 'date-fns-tz';
import { isAfter, isBefore, isEqual, parseISO } from 'date-fns'; 

// Função auxiliar para formatar números com zero à esquerda (mantida)
function formatLeadingZero(text) {
    if (!text && text !== 0) return '000';
    const num = parseInt(text);
    if (num < 10) {
        return `00${num}`;
    } else if (num < 100) {
        return `0${num}`;
    } else {
        return `${num}`;
    }
}

// 🚀 NOVO: Função para converter quebras de linha (\n) em tags HTML <br /> 
const createMarkup = (htmlString) => {
    if (!htmlString) return { __html: '' };
    
    // Substitui '\n\n' (parágrafos) por duas quebras de linha
    const processedHtml = htmlString
        .replace(/\n\n/g, '<br /><br />')
        // Substitui quebras de linha simples restantes por uma quebra de linha
        .replace(/\n/g, '<br />');

    // Retorna o objeto esperado pelo dangerouslySetInnerHTML
    return { __html: processedHtml };
};


function AeflorCard(props) {
    const { inscrito, inscfim, dataevento, codevento, status, erro } = props;
    
    const dateInscFim = inscfim ? parseISO(inscfim) : null;
    const dateDataEvento = dataevento ? parseISO(dataevento) : null;
    const today = new Date();

    const formatDate = (dateString, format) => {
        if (!dateString) return '';
        try {
            const date = dateString.substring(0, 23);
            return formatInTimeZone(date, 'America/Sao_Paulo', format);
        } catch (error) {
            console.error("Erro ao formatar data:", error);
            return dateString;
        }
    };

    const dataEventoFormatada = formatDate(dataevento, "dd'/'MM'/'yyyy ' às ' HH:mm");
    const inscInicioFormatada = formatDate(props.inscinicio, "dd/MM 'às' HH:mm");
    const inscFimFormatada = formatDate(inscfim, "dd/MM/yyyy 'às' HH:mm");

    const inscricaoAtiva = status === 'A' && erro === null;
    const inscricaoEncerrada = dateInscFim && isAfter(today, dateInscFim);
    const showTicketButton = inscrito && inscricaoEncerrada && dateDataEvento && (isBefore(today, dateDataEvento) || isEqual(today, dateDataEvento));

    const handleInscricaoClick = () => {
        if (codevento) {
            localStorage.setItem("codevento", codevento);
        } else {
            console.error("props.codevento está indefinido!");
        }
    };

    return (
        <div className="event-hero-card">

            <div className="row g-0">
                <div className="col-lg-5 order-lg-2">
                    <img
                        className="event-image img-fluid clickable-image"
                        src={props.fotolink}
                        alt={props.nomeevento}
                        onClick={() => props.onImageClick(props.fotolink, props.nomeevento)} 
                        title="Clique para ampliar"
                    />
                </div>

                <div className="col-lg-7 order-lg-1 event-content-area">
                    <div className="event-content-wrapper">
                        <h1 className="event-title">{props.nomeevento}</h1>
                        
                        {/* 🚀 TRECHO AJUSTADO: Usa createMarkup e dangerouslySetInnerHTML */}
                        <h3 
                            className="event-description"
                            dangerouslySetInnerHTML={createMarkup(props.descricao)} 
                        />
                        {/* 🚀 FIM DO TRECHO AJUSTADO */}

                        <div className="event-info-block">
                            <p className="info-item event-date">
                                <i className="fas fa-calendar-alt"></i> Data do Evento: <strong>{dataEventoFormatada}</strong>
                            </p>

                            {status === 'A' && (
                                <p className="info-item registration-period">
                                    <i className="fas fa-edit"></i> Inscrições: 
                                    <strong> de {inscInicioFormatada} até {inscFimFormatada}</strong>
                                </p>
                            )}
                        </div>

                        <div className="event-cta mt-4">
                            {inscricaoAtiva && !inscrito ? (
                                <Link 
                                    to={'/arbor/aeflor/inscricao/'} 
                                    className="btn-primary-aeflor"
                                    onClick={handleInscricaoClick}
                                >
                                    <i className="fas fa-check-circle"></i> Inscreva-se Agora
                                </Link>
                            ) : inscricaoAtiva && inscrito ? (
                                <Link
                                    to={'/arbor/aeflor/inscricao/'} 
                                    className="btn-primary-aeflor existing-inscription-link"
                                    onClick={handleInscricaoClick}
                                >
                                    <i className="fas fa-check"></i> Você já está inscrito! Clique para gerenciar.
                                </Link>
                            ) : (
                                <div className="alert-message">
                                    <i className="fas fa-ban"></i> {erro || 'Inscrição não iniciada ou encerrada.'}
                                </div>
                            )}
                        </div>
                        
                        <div className="event-cta mt-4">
                            {showTicketButton ? (
                                <Link 
                                    to={'/arbor/aeflor/ingresso/'} 
                                    className="btn-primary-aeflor ticket-button"
                                    onClick={handleInscricaoClick}
                                >
                                    <i className="fa fa-address-card-o"></i> Seu ingresso foi solicitado, clique para ver
                                </Link>
                            ) : (
                                !inscricaoEncerrada && !inscrito && (
                                    <div className="alert-message alert-info">
                                        <i className="fas fa-info-circle"></i> Faça sua inscrição para emitir o ingresso.
                                    </div>
                                )
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <div className="attendance-stats">
                <div className="stat-item">
                    <i className="fas fa-users"></i>
                    <span className="stat-label">Funcionários Inscritos</span>
                    <span className="stat-count">{formatLeadingZero(props.funcionarios)}</span> 
                </div>
                <div className="stat-item">
                    <i className="fas fa-user-friends"></i>
                    <span className="stat-label">Dependentes Inscritos</span>
                    <span className="stat-count">{formatLeadingZero(props.dependentes)}</span>
                </div>
            </div>
        </div>
    );
}

export default AeflorCard;